<template>
	<div class="views">1</div>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {};
	},
	mounted() {
		window.open('http://www.hngtsd.net:80/BricsContest/Index', 'theFrame', '', false);
	},
	created() {
		AppOptions.appEmpty = true;
	},
	beforeDestroy() {},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	}
};
</script>

<style scoped>
.views {
	width: 100%;
	min-height: 100vh;
}
</style>
